import * as actionTypes from './actionTypes/index.js'
import * as actions from './actions'
import reducer from './reducer'

export { actionTypes, actions, reducer }

export default {
  ...actionTypes,
  ...actions,
  reducer
}
